export default "__VITE_ASSET__DhX7g57X__"